import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/lems-v1/images/calendar.svg'
import _imports_1 from '@/assets/lems-v1/images/full-size.svg'
import _imports_2 from '@/assets/lems-v1/images/close-black-icon.svg'
import _imports_3 from '@/assets/lems-v1/images/viewavatar.svg'


const _hoisted_1 = {
  class: "activity-stream-box",
  id: "activityShow"
}
const _hoisted_2 = { class: "activity-stream-box-in" }
const _hoisted_3 = { class: "activity-stream-box-top" }
const _hoisted_4 = { class: "calendar-drop-down-content" }
const _hoisted_5 = { class: "calendar-drop-down-content-inner" }
const _hoisted_6 = { class: "choose-calendar" }
const _hoisted_7 = { class: "custom-filter" }
const _hoisted_8 = { class: "activity-stream-list" }
const _hoisted_9 = {
  key: 0,
  class: "loading-data-text"
}
const _hoisted_10 = {
  key: 0,
  class: "activity-long"
}
const _hoisted_11 = {
  key: 1,
  class: "activity-stream-details"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "activity-stream-text" }
const _hoisted_14 = { class: "activity-stream-rept" }
const _hoisted_15 = { href: "#" }
const _hoisted_16 = { class: "activity-stream-ul" }
const _hoisted_17 = {
  key: 2,
  class: "activity-long"
}
const _hoisted_18 = {
  key: 3,
  class: "activity-stream-details"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "activity-stream-text" }
const _hoisted_21 = { class: "activity-stream-rept" }
const _hoisted_22 = { href: "#" }
const _hoisted_23 = { class: "activity-stream-ul" }
const _hoisted_24 = {
  key: 4,
  class: "activity-long"
}
const _hoisted_25 = {
  key: 5,
  class: "activity-stream-details"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "activity-stream-text" }
const _hoisted_28 = { class: "activity-stream-rept" }
const _hoisted_29 = { href: "#" }
const _hoisted_30 = { class: "activity-stream-ul" }
const _hoisted_31 = {
  key: 0,
  class: "pagination-box"
}
const _hoisted_32 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ACTIVITY_STREAM_TEXT), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["calendar-drop-down-box", { 'show-calendar-dropdown': _ctx.isCalendarOpen }])
        }, [
          _createElementVNode("div", {
            class: "calendar-drop-down-icon",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCalendarOpen = !_ctx.isCalendarOpen))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                    _ctx.validateDate
                  ],
                  inline: "",
                  "max-date": new Date()
                }, null, 8, ["modelValue", "onUpdate:modelValue", "max-date"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  id: "allCalendarBtn",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setDateFilter('all'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'all' })
                }, "All", 2),
                _createElementVNode("button", {
                  id: "lastWeekCalendarBtn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setDateFilter('last_week'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'last_week' })
                }, "Last Week", 2),
                _createElementVNode("button", {
                  id: "lastMonthCalendarBtn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setDateFilter('last_month'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'last_month' })
                }, "Last Month", 2),
                _createElementVNode("button", {
                  id: "lastYearCalendarBtn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setDateFilter('last_year'))),
                  class: _normalizeClass({ active: _ctx.selectedDateFilter === 'last_year' })
                }, "Last Year", 2)
              ])
            ])
          ])
        ], 2),
        _cache[9] || (_cache[9] = _createElementVNode("button", {
          id: "activityFullbtn",
          class: "view-full-size"
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: ""
          })
        ], -1)),
        _cache[10] || (_cache[10] = _createElementVNode("button", {
          id: "activityClosebtn",
          class: "view-close-size"
        }, [
          _createElementVNode("img", {
            src: _imports_2,
            alt: ""
          })
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("p", null, "Loading activity...", -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.groupedActivities.today.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.TODAY_TEXT), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.groupedActivities.today.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedActivities.today, (activity) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "activity-stream-row",
                        key: activity.id
                      }, [
                        _createElementVNode("span", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "user-status user-status-active" }, null, -1)),
                          (activity.userAvatar)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: activity.userAvatar,
                                alt: ""
                              }, null, 8, _hoisted_12))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("h5", null, [
                              _createTextVNode(_toDisplayString(activity.userDisplayName || 'Unknown') + " ", 1),
                              _cache[13] || (_cache[13] = _createElementVNode("i", null, "updated", -1)),
                              _createElementVNode("a", _hoisted_15, _toDisplayString(activity.issueKey) + " - " + _toDisplayString(activity.summary), 1)
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _cache[14] || (_cache[14] = _createElementVNode("i", null, [
                                    _createElementVNode("img", {
                                      src: _imports_3,
                                      alt: ""
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(activity.agoValue) + " " + _toDisplayString(activity.agoUnit === 'min' ? _ctx.constants.PLURAL_MIN_TEXT : _ctx.constants.PLURAL_HR_TEXT), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.groupedActivities.yesterday.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.YESTERDAY_TEXT), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.groupedActivities.yesterday.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedActivities.yesterday, (activity) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "activity-stream-row",
                        key: activity.id
                      }, [
                        _createElementVNode("span", null, [
                          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "user-status user-status-active" }, null, -1)),
                          (activity.userAvatar)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: activity.userAvatar,
                                alt: ""
                              }, null, 8, _hoisted_19))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("h5", null, [
                              _createTextVNode(_toDisplayString(activity.userDisplayName || 'Unknown') + " ", 1),
                              _cache[16] || (_cache[16] = _createElementVNode("i", null, "updated", -1)),
                              _createElementVNode("a", _hoisted_22, _toDisplayString(activity.issueKey) + " - " + _toDisplayString(activity.summary), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _cache[17] || (_cache[17] = _createElementVNode("i", null, [
                                    _createElementVNode("img", {
                                      src: _imports_3,
                                      alt: ""
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(activity.agoValue) + " " + _toDisplayString(activity.agoUnit === 'min' ? _ctx.constants.PLURAL_MIN_TEXT : _ctx.constants.PLURAL_HR_TEXT), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.groupedActivities.earlier.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("span", null, " Earlier ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_ctx.groupedActivities.earlier.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedActivities.earlier, (activity) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "activity-stream-row",
                        key: activity.id
                      }, [
                        _createElementVNode("span", null, [
                          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "user-status user-status-active" }, null, -1)),
                          (activity.userAvatar)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: activity.userAvatar,
                                alt: ""
                              }, null, 8, _hoisted_26))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("h5", null, [
                              _createTextVNode(_toDisplayString(activity.userDisplayName || 'Unknown') + " ", 1),
                              _cache[20] || (_cache[20] = _createElementVNode("i", null, "updated", -1)),
                              _createElementVNode("a", _hoisted_29, _toDisplayString(activity.issueKey) + " - " + _toDisplayString(activity.summary), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, [
                                  _cache[21] || (_cache[21] = _createElementVNode("i", null, [
                                    _createElementVNode("img", {
                                      src: _imports_3,
                                      alt: ""
                                    })
                                  ], -1)),
                                  _createTextVNode(" " + _toDisplayString(activity.agoValue) + " " + _toDisplayString(activity.agoUnit === 'min' ? _ctx.constants.PLURAL_MIN_TEXT : _ctx.constants.PLURAL_HR_TEXT), 1)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      (_ctx.totalPages > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createElementVNode("ul", null, [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: "pagination-first",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                  }, [...(_cache[22] || (_cache[22] = [
                    _createElementVNode("button", { id: "paginationPreButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  onClick: ($event: any) => (_ctx.changePage(page))
                }, [
                  _createElementVNode("a", {
                    href: "#",
                    class: _normalizeClass({ active: _ctx.currentPage === page })
                  }, _toDisplayString(page), 3)
                ], 8, _hoisted_32))
              }), 128)),
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "pagination-last",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                  }, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("button", { id: "paginationNextButton" }, null, -1)
                  ]))]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}